export enum IconSize {
  FONT_10 = "i-10",
  FONT_16 = "i-16",
  FONT_20 = "i-20",
  FONT_24 = "i-24",
  FONT_30 = "i-30",
  FONT_50 = "i-50",
  FONT_64 = "i-64",
}
